import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "../../../../../components/table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData } from "./infoenum";

class NetScanResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedData: []
    };
  }

  sortData = data => {
    let sortedData = [];
    let conflict = data
      .filter(item => {
        return item.addressconflict == 1;
      })
      .map(item => {
        sortedData.push(item);
      });
    let ipv4 = data
      .filter(item => {
        return item.ipv6 == 0 && item.addressconflict == 0;
      })
      .map(item => {
        sortedData.push(item);
      });
    let ipv6 = data
      .filter(item => {
        return item.ipv6 == 1 && item.addressconflict == 0;
      })
      .map(item => {
        sortedData.push(item);
      });
    return sortedData;
  };

  render() {
    const {
      classes,
      result,
      subtest,
      subtestSignaltekResults,
      netScanResultDetail,
      translate,
      pager,
      fetch
    } = this.props;
    let { sortedData } = this.state;
    //let sortedData = [];
    // if (netScanResultDetail && netScanResultDetail.data)
    //   sortedData = this.sortData(netScanResultDetail.data);
    return subtestSignaltekResults &&
      sortedData &&
      sortedData.length > 0 &&
      netScanResultDetail &&
      subtestSignaltekResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestSignaltekResults.teststarted
                  ? moment(subtestSignaltekResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_test_duration")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.testduration
                  ? subtestSignaltekResults.testduration
                  : "00:00:10"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_scan_range")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.scanrange}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_ipv4_hosts")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.ipv4host}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_ipv6_hosts")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.ipv6host}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_add_conflicts")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.addressconflict}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "7px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestSignaltekResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {infoData.find(
                        o => o.name === subtestSignaltekResults.info
                      )
                        ? " " +
                          translate(
                            infoData.find(
                              o => o.name === subtestSignaltekResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
          </Grid>
          <div className={classes.div_table}>
            <Table
              translate={translate}
              filterable={false}
              minRows={0}
              pages={netScanResultDetail.pagecount}
              manual={pager.manual}
              defaultPageSize={pager.pagesize}
              data={sortedData}
              columns={this.state.columns}
              pager={pager}
              fetch={fetch}
              isSGResultView={true}
              style={{
                border: "none"
              }}
            />
          </div>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }

  componentWillMount() {
    const {
      classes,
      getSubtestResults,
      subtest,
      pager,
      getNetScanResult,
      netScanResultDetail
    } = this.props;

    let pagerNew = {
      manual: true,
      pageno: 1,
      pagesize: 50,
      order: {},
      search: [],
      jid: pager.jid,
      tid: pager.tid,
      global: false
    };

    getSubtestResults(pager.jid, pager.tid, subtest, null);
    getNetScanResult(pagerNew);

    let columns = [];
    let columnsCount = columns.push(
      {
        id: "id",
        accessor: d => d["ipaddress"],
        show: false,
        toggle: false,
        display: false,
        filterable: false,
        cansearch: false,
        sortable: false
      },
      {
        id: "ipaddress",
        Header: this.props.translate("ip_address"),
        accessor: d => d["ipaddress"],
        show: true,
        toggle: true,
        display: true,
        filterable: false,
        cansearch: false,
        sortable: true,
        width: Math.round(window.innerWidth * 0.1),
        Cell: o =>
          o.row._original.addressconflict === 1 ? (
            <Typography className={classes.failState}>
              {o.row.ipaddress}
            </Typography>
          ) : (
            <Typography>{o.row.ipaddress}</Typography>
          )
      },
      {
        id: "macaddress",
        Header: this.props.translate("mac_addr"),
        accessor: d => d["macaddress"],
        show: true,
        toggle: true,
        display: true,
        filterable: false,
        cansearch: false,
        sortable: true,
        width: Math.round(window.innerWidth * 0.1)
      },
      {
        id: "vendor",
        Header: this.props.translate("result_vendor") + ": ",
        accessor: d => d["vendor"],
        show: true,
        toggle: true,
        display: true,
        filterable: false,
        cansearch: false,
        sortable: true,
        minwidth: Math.round(window.innerWidth * 0.2)
      },
      {
        id: "host",
        Header: this.props.translate("host_name"),
        accessor: d => d["host"],
        show: true,
        toggle: true,
        display: true,
        filterable: false,
        cansearch: false,
        sortable: true,
        minwidth: Math.round(window.innerWidth * 0.2),
        Cell: o => (
          <React.Fragment>{o.row.host ? o.row.host : "-"}</React.Fragment>
        )
      }
    );
    this.setState({
      columns: columns
    });
    if (netScanResultDetail && netScanResultDetail.data) {
      let sortedData = this.sortData(netScanResultDetail.data);
      this.setState({
        sortedData
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      getSubtestResults,
      subtest,
      pager,
      getNetScanResult,
      netScanResultDetail
    } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getSubtestResults(pager.jid, pager.tid, subtest, null);
      getNetScanResult(pager);
    }
    if (this.props.netScanResultDetail !== netScanResultDetail) {
      //let sortedData = this.sortData(netScanResultDetail.data);
      if (
        this.props.pager.pageno != 1 ||
        Object.keys(this.props.pager.order).length > 0
      ) {
        this.setState({ sortedData: netScanResultDetail.data });
      } else if (
        this.props.pager.pageno == 1 ||
        Object.keys(this.props.pager.order).length == 0
      ) {
        let sortedData = this.sortData(netScanResultDetail.data);
        this.setState({
          sortedData
        });
      }
    }
  }
}

export default withStyles(styles)(NetScanResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/netscan/index.js